import { BasicButtonToggling } from "../../modules/basic-button-toggling";


export class ADP extends BasicButtonToggling {
    public loadMoreBtn = document.querySelector('[data-adp-more]');
    public openPanel = document.getElementById(this.loadMoreBtn.getAttribute("aria-controls"));
    public loadMoreBtnText = "Load More";
    public showLessBtnText = "Show Less";
    constructor() {
        super();
        this.activateLoadMore();
    }

    activateLoadMore() {
        this.loadMoreBtn.addEventListener('click', (e) => {
            this.handleClick(e);
            this.updateText();
            this.focusToOpenPanel();
        });
    }

    updateText() {
        this.loadMoreBtn.innerHTML = (this.loadMoreBtn.getAttribute('aria-expanded') === "true") ? this.showLessBtnText : this.loadMoreBtnText;
    }

    focusToOpenPanel() {
        if (this.loadMoreBtn.getAttribute('aria-expanded') === "true") {
            this.openPanel.tabIndex = -1;
            this.openPanel.focus();
        }
            
    }
    
}

(function playDetails() {
    new ADP(); 
})();